{
    "fr": 60,
    "h": 4,
    "ip": 0,
    "layers": [
        {
            "ind": 3,
            "ty": 4,
            "parent": 2,
            "ks": {},
            "ip": 0,
            "op": 241,
            "st": 0,
            "shapes": [
                {
                    "ty": "rc",
                    "p": {
                        "a": 0,
                        "k": [
                            93.75,
                            2
                        ]
                    },
                    "r": {
                        "a": 0,
                        "k": 0
                    },
                    "s": {
                        "a": 0,
                        "k": [
                            187.5,
                            4
                        ]
                    }
                },
                {
                    "ty": "gf",
                    "e": {
                        "a": 0,
                        "k": [
                            187.5,
                            2
                        ]
                    },
                    "g": {
                        "p": 4,
                        "k": {
                            "a": 0,
                            "k": [
                                0,
                                0.706,
                                0.925,
                                0.875,
                                0.335,
                                0.969,
                                0.914,
                                0.671,
                                0.675,
                                0.961,
                                0.761,
                                0.796,
                                1,
                                0.706,
                                0.925,
                                0.875
                            ]
                        }
                    },
                    "t": 1,
                    "o": {
                        "a": 0,
                        "k": 100
                    },
                    "s": {
                        "a": 0,
                        "k": [
                            0,
                            2
                        ]
                    }
                }
            ]
        },
        {
            "ind": 2,
            "ty": 3,
            "parent": 1,
            "ks": {
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "t": 0,
                            "s": [
                                -189,
                                0
                            ],
                            "i": {
                                "x": [
                                    1,
                                    1
                                ],
                                "y": [
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0,
                                    0
                                ],
                                "y": [
                                    0,
                                    0
                                ]
                            }
                        },
                        {
                            "t": 60,
                            "s": [
                                -189,
                                0
                            ],
                            "i": {
                                "x": [
                                    1,
                                    1
                                ],
                                "y": [
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0,
                                    0
                                ],
                                "y": [
                                    0,
                                    0
                                ]
                            }
                        },
                        {
                            "t": 120,
                            "s": [
                                379,
                                0
                            ],
                            "i": {
                                "x": [
                                    1,
                                    1
                                ],
                                "y": [
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0,
                                    0
                                ],
                                "y": [
                                    0,
                                    0
                                ]
                            }
                        },
                        {
                            "t": 240,
                            "s": [
                                379,
                                0
                            ],
                            "h": 1
                        }
                    ]
                }
            },
            "ip": 0,
            "op": 241,
            "st": 0
        },
        {
            "ind": 5,
            "ty": 4,
            "parent": 4,
            "ks": {},
            "ip": 0,
            "op": 241,
            "st": 0,
            "shapes": [
                {
                    "ty": "rc",
                    "p": {
                        "a": 0,
                        "k": [
                            187.5,
                            2
                        ]
                    },
                    "r": {
                        "a": 0,
                        "k": 0
                    },
                    "s": {
                        "a": 0,
                        "k": [
                            375,
                            4
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 0,
                        "k": [
                            0.984,
                            0.827,
                            0.549
                        ]
                    },
                    "o": {
                        "a": 0,
                        "k": 100
                    }
                }
            ]
        },
        {
            "ind": 4,
            "ty": 3,
            "parent": 1,
            "ks": {
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "t": 0,
                            "s": [
                                0,
                                -4
                            ],
                            "i": {
                                "x": [
                                    1,
                                    0
                                ],
                                "y": [
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0,
                                    0.5
                                ],
                                "y": [
                                    0,
                                    0
                                ]
                            }
                        },
                        {
                            "t": 60,
                            "s": [
                                0,
                                0
                            ],
                            "i": {
                                "x": [
                                    1,
                                    1
                                ],
                                "y": [
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0,
                                    0
                                ],
                                "y": [
                                    0,
                                    0
                                ]
                            }
                        },
                        {
                            "t": 120,
                            "s": [
                                0,
                                0
                            ],
                            "i": {
                                "x": [
                                    1,
                                    0
                                ],
                                "y": [
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0,
                                    0.5
                                ],
                                "y": [
                                    0,
                                    0
                                ]
                            }
                        },
                        {
                            "t": 180,
                            "s": [
                                0,
                                -4
                            ],
                            "i": {
                                "x": [
                                    1,
                                    1
                                ],
                                "y": [
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0,
                                    0
                                ],
                                "y": [
                                    0,
                                    0
                                ]
                            }
                        },
                        {
                            "t": 240,
                            "s": [
                                0,
                                -4
                            ],
                            "h": 1
                        }
                    ]
                }
            },
            "ip": 0,
            "op": 241,
            "st": 0
        },
        {
            "ind": 1,
            "ty": 3,
            "parent": 0,
            "ks": {},
            "ip": 0,
            "op": 241,
            "st": 0
        },
        {
            "ind": 6,
            "ty": 4,
            "parent": 0,
            "ks": {},
            "ip": 0,
            "op": 241,
            "st": 0,
            "shapes": [
                {
                    "ty": "rc",
                    "p": {
                        "a": 0,
                        "k": [
                            187.5,
                            2
                        ]
                    },
                    "r": {
                        "a": 0,
                        "k": 0
                    },
                    "s": {
                        "a": 0,
                        "k": [
                            375,
                            4
                        ]
                    }
                },
                {
                    "ty": "fl",
                    "c": {
                        "a": 0,
                        "k": [
                            1,
                            1,
                            1
                        ]
                    },
                    "o": {
                        "a": 0,
                        "k": 100
                    }
                }
            ]
        },
        {
            "ind": 0,
            "ty": 3,
            "ks": {},
            "ip": 0,
            "op": 241,
            "st": 0
        }
    ],
    "meta": {
        "g": "https://jitter.video"
    },
    "op": 240,
    "v": "5.7.4",
    "w": 375
}